import { FilterControlsConfig, ToggleFilterConfig } from '@lbcamden/lib-react';
import { parseDate } from '@lbcamden/shared-utils';
import { DateTime } from 'luxon';

import { FireSafetyNote } from '~/common/types/notes';
import { PcfraDocument } from '~/common/types/pcfra';

import {
  AnyHistoryItem,
  DocumentHistoryItem,
  NoteHistoryItem,
  ResidentHistoryFilterParams,
} from './types';

const toggleFilters: ToggleFilterConfig<ResidentHistoryFilterParams, 'type'>[] = [
  { type: 'toggle', key: 'type', label: 'Notes', activeValue: 'note' },
  { type: 'toggle', key: 'type', label: 'Documents', activeValue: 'document' },
];

export const filterConfigs: FilterControlsConfig<ResidentHistoryFilterParams> = [toggleFilters];

export const noteToHistoryItem = (note: FireSafetyNote): NoteHistoryItem => ({
  id: note.noteId,
  type: 'note',
  timestamp: note.created,
  data: note,
});

export const documentToHistoryItem = (document: PcfraDocument): DocumentHistoryItem => ({
  id: String(document.documentId),
  type: 'document',
  timestamp: document.created,
  data: document,
});

export const getTimePeriodGroupName = ({ timestamp }: AnyHistoryItem) => {
  const date = parseDate(timestamp);
  const oneWeekAgo = DateTime.now().minus({ week: 1 });

  return date > oneWeekAgo ? 'Last 7 days' : `${date.monthLong} ${date.year}`;
};
